import { useEffect, useState } from 'react';
const DEFAULT_DELAY = 400;
export function useDelayUnmount(isMounted, delayTime = DEFAULT_DELAY) {
    const [isVisible, setVisible] = useState(false);
    useEffect(() => {
        let timeoutId;
        if (isMounted && !isVisible) {
            setVisible(true);
        }
        else if (!isMounted && isVisible) {
            timeoutId = setTimeout(() => setVisible(false), delayTime);
        }
        return () => clearTimeout(timeoutId);
    }, [isMounted, delayTime, isVisible]);
    return isVisible;
}
